<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['item.no']" :addon-before="$t('business.label.itemNo')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.name']" :addon-before="$t('business.label.itemName')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['location.no']" :addon-before="$t('business.label.locationNo')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['container.no']" :addon-before="$t('business.label.containerNo')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="batch.no" title="business.label.batchNo"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="inventory.availableQuantity" title="business.label.availableQuantity"/>
      <vxe-column field="inventory.quantity" title="business.label.quantity"/>
      <vxe-column field="inventory.inventoryState" title="business.label.inventoryStatus">
        <span slot-scope="{ row }">{{inventoryStateData.find(item => item.ordinal === row.inventory.inventoryState).name}}</span>
      </vxe-column>
      <vxe-column field="inventory.availableOutboundQuantity" title="business.label.availableOutboundQuantity"/>
      <vxe-column field="inventory.lockedQuantity" title="business.label.lockedQuantity"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <InventoryLockConfirmModal ref="inventoryLockConfirmModal" @success="success"/>
  </a-layout>
</template>
<script>
import { findAll } from '@/api/Api'
import InventoryLockConfirmModal from '@/views/warehouse_management/inventory_lock/InventoryLockConfirmModal.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'InventoryLockingTable',
  components: {
    InventoryLockConfirmModal
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': false
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77)// 表格竖向滚动条
    }
  },
  props: {
    inventoryStateData: {
      type: Array,
      default: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': false
      }
      this.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('inventoryFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setCurrentRow(this.data[0])
            this.$refs.table.setRadioRow(this.data[0])
          }
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      this.lock()
    },
    lock() {
      let selectedRow = this.$refs.table.getCurrentRecord()
      if (selectedRow === null) {
        return this.$message.warning('请选中需要锁定库存')
      }
      this.$refs.inventoryLockConfirmModal.open(selectedRow)
    },
    success() {
      this.getData()
      this.$emit('success')
    }
  }
}
</script>
